import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { MONTH_OPTIONS, yearOptions } from "@/lib/format";

export default function PeriodPicker({ period, onChange, testidPrefix = "period" }) {
  const [y, m] = (period || "2026-01").split("-");
  const setMonth = (mm) => onChange(`${y}-${mm}`);
  const setYear = (yy) => onChange(`${yy}-${m}`);
  return (
    <div className="flex gap-2 items-center">
      <Select value={m} onValueChange={setMonth}>
        <SelectTrigger className="w-[130px] h-10 bg-white" data-testid={`${testidPrefix}-month`}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {MONTH_OPTIONS.map((o) => (
            <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select value={y} onValueChange={setYear}>
        <SelectTrigger className="w-[100px] h-10 bg-white" data-testid={`${testidPrefix}-year`}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {yearOptions().map((yy) => (
            <SelectItem key={yy} value={String(yy)}>{yy}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
